import {
  calculatePromotionValue,
  CurrencyCode,
  formatCurrency,
  GiftItemType,
  isPromotionDisabled,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {
  getBasketItemValue,
} from '../../../helpers/basketHelper'
import { IBasketItem } from '../../../types/dataTypes'

const PriceLabel = styled.div`
  font-size: 0.85em;
  color: #666;
  margin-bottom: 2px;
  text-align: right;
`

interface IItemPriceProps {
  item: IBasketItem
  currencyCode: CurrencyCode
}
export default function ItemPrice({
  item,
  currencyCode,
}: IItemPriceProps): ReactElement {
  const value = getBasketItemValue(item, false)
  const freeText = value === 0 ? 'Free' : false
  const valueText = freeText || (value && formatCurrency(value, currencyCode))

  // Check if promotion is disabled, but allow applied promotions via promo code
  const disablePromotion = !item.promotion && isPromotionDisabled(item.giftItem)
  if (!item.promotion || disablePromotion) return <div>{valueText}</div>

  const isMonetary = item.giftItem.type === GiftItemType.Monetary
    || item.giftItem.value?.includes(',')
  const individualsMultiplier = item.individuals || 1

  const { salePrice, faceValue, addedAmount } = calculatePromotionValue(
    value,
    item.promotion,
    individualsMultiplier,
    isMonetary,
  )
  const formattedSalePrice = formatCurrency(salePrice, currencyCode)

  // For additive promotions, show both face value and sale price
  if (addedAmount > 0) {
    const formattedFaceValue = formatCurrency(faceValue, currencyCode)
    return (
      <>
        <div>
          <PriceLabel>
            Face value:
            {' '}
            {formattedFaceValue}
          </PriceLabel>
        </div>
        <div>
          <PriceLabel>
            Sale price:
            {' '}
            {salePrice <= 0 ? 'Free' : formattedSalePrice}
          </PriceLabel>
        </div>
      </>
    )
  }

  return (
    <>
      <div>
        <PriceLabel>
          Face value:
          {' '}
          {valueText}
        </PriceLabel>
      </div>
      <div>
        <PriceLabel>
          Sale price:
          {' '}
          {salePrice <= 0 ? 'Free' : formattedSalePrice}
        </PriceLabel>
      </div>
    </>
  )
}
